// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.TransferDialogue_dialogueBox__NpwmG {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  flex-shrink: 0;
  border-radius: 8px;
  background: var(--background-secondary, #fff);
  /* ◻️ Light/action_shadow */
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  padding: 20px;
}

.TransferDialogue_topHeading__9l594 {
  color: var(--text-primary, #1f2023);
  /* Subheadline/Bold */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 125% */
  letter-spacing: -0.5px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}
.TransferDialogue_topHeading__9l594 span {
  display: flex;
  gap: 10px;
}

.TransferDialogue_transferBox__uth\\+G {
  display: flex;
  gap: 10px;
  padding: 4px 0px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  background: var(--background-quaternary, #f7f9fc);
  margin-bottom: 30px;
}
.TransferDialogue_transferBox__uth\\+G div {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
}
.TransferDialogue_transferBox__uth\\+G div label {
  color: var(--text-primary, #1f2023);
  /* Body/Regular */
  font-family: Poppins;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 133.333% */
  letter-spacing: -0.5px;
}

.TransferDialogue_row__8ncys {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 30px;
  padding: 8px 15px;
  border-bottom: 1px solid var(--border-secondary, #c8d3e0);
  position: relative;
}
.TransferDialogue_row__8ncys span {
  position: absolute;
  top: 50%;
  right: 5px;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.TransferDialogue_row__8ncys label {
  color: var(--text-secondary, #5c6168);
  /* Caption 1/Regular */
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 138.462% */
  letter-spacing: -0.2px;
  width: -moz-fit-content;
  width: fit-content;
  flex-shrink: 0;
}
.TransferDialogue_row__8ncys input {
  color: var(--text-primary, #1f2023);
  /* Caption 1/Regular */
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 138.462% */
  letter-spacing: -0.2px;
  width: 100%;
  padding: 4px 15px;
}

.TransferDialogue_btnBox__p6GqR {
  display: flex;
  justify-content: end;
}
.TransferDialogue_btnBox__p6GqR button {
  display: flex;
  padding: 7px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  background: var(--primary-default, #0c6dc7);
  color: var(--text-on-color, #fff);
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 138.462% */
  letter-spacing: -0.5px;
}

.TransferDialogue_closeBox__7yybU {
  cursor: pointer;
}

.TransferDialogue_disabled__cE-sC {
  cursor: default;
  background: var(--primary-disabled, #c8d3e0) !important;
}

@media only screen and (max-width: 500px) {
  .TransferDialogue_dialogueBox__NpwmG {
    top: unset;
    bottom: 0;
    left: 0;
    transform: unset;
    width: 100%;
  }
  .TransferDialogue_btnBox__p6GqR button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Sidecar/ActionsDialogue/TransferDialogue/TransferDialogue.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EAEA,YAAA;EAEA,cAAA;EACA,kBAAA;EACA,6CAAA;EAEA,2BAAA;EACA,gDAAA;EACA,aAAA;EAEA,aAAA;AAFD;;AAOA;EACC,mCAAA;EAEA,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,sBAAA;EAEA,aAAA;EACA,8BAAA;EAEA,mBAAA;AAPD;AASC;EACC,aAAA;EACA,SAAA;AAPF;;AAWA;EACC,aAAA;EACA,SAAA;EAEA,gBAAA;EACA,sBAAA;EACA,uBAAA;EAEA,kBAAA;EACA,iDAAA;EAEA,mBAAA;AAXD;AAaC;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAXF;AAaE;EACC,mCAAA;EAEA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;AAZH;;AAiBA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EAEA,mBAAA;EACA,iBAAA;EAEA,yDAAA;EAEA,kBAAA;AAjBD;AAmBC;EACC,kBAAA;EACA,QAAA;EACA,UAAA;EACA,gCAAA;EACA,eAAA;AAjBF;AAoBC;EACC,qCAAA;EAEA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;EAEA,uBAAA;EAAA,kBAAA;EACA,cAAA;AApBF;AAuBC;EACC,mCAAA;EAEA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;EAEA,WAAA;EACA,iBAAA;AAvBF;;AA2BA;EACC,aAAA;EACA,oBAAA;AAxBD;AA0BC;EACC,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EAEA,kBAAA;EACA,2CAAA;EAEA,iCAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;AA1BF;;AA6BA;EACC,eAAA;AA1BD;;AA4BA;EACC,eAAA;EACA,uDAAA;AAzBD;;AA4BA;EACC;IACC,UAAA;IACA,SAAA;IACA,OAAA;IACA,gBAAA;IACA,WAAA;EAzBA;EA6BA;IACC,WAAA;EA3BD;AACF","sourcesContent":[".dialogueBox {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\n\twidth: 400px;\n\t// height: 100%;\n\tflex-shrink: 0;\n\tborder-radius: 8px;\n\tbackground: var(--background-secondary, #fff);\n\n\t/* ◻️ Light/action_shadow */\n\tbox-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);\n\tz-index: 1000;\n\n\tpadding: 20px;\n\n\t// position: relative;\n}\n\n.topHeading {\n\tcolor: var(--text-primary, #1f2023);\n\n\t/* Subheadline/Bold */\n\tfont-family: Poppins;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 20px; /* 125% */\n\tletter-spacing: -0.5px;\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\tmargin-bottom: 30px;\n\n\tspan {\n\t\tdisplay: flex;\n\t\tgap: 10px;\n\t}\n}\n\n.transferBox {\n\tdisplay: flex;\n\tgap: 10px;\n\t// width: 332px;\n\tpadding: 4px 0px;\n\tflex-direction: column;\n\talign-items: flex-start;\n\n\tborder-radius: 8px;\n\tbackground: var(--background-quaternary, #f7f9fc);\n\n\tmargin-bottom: 30px;\n\n\tdiv {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 8px;\n\t\tpadding: 8px;\n\n\t\tlabel {\n\t\t\tcolor: var(--text-primary, #1f2023);\n\n\t\t\t/* Body/Regular */\n\t\t\tfont-family: Poppins;\n\t\t\tfont-size: 15px;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 20px; /* 133.333% */\n\t\t\tletter-spacing: -0.5px;\n\t\t}\n\t}\n}\n\n.row {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 10px;\n\n\tmargin-bottom: 30px;\n\tpadding: 8px 15px;\n\n\tborder-bottom: 1px solid var(--border-secondary, #c8d3e0);\n\n\tposition: relative;\n\n\tspan {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tright: 5px;\n\t\ttransform: translate(-50%, -50%);\n\t\tcursor: pointer;\n\t}\n\n\tlabel {\n\t\tcolor: var(--text-secondary, #5c6168);\n\n\t\t/* Caption 1/Regular */\n\t\tfont-family: Poppins;\n\t\tfont-size: 13px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 18px; /* 138.462% */\n\t\tletter-spacing: -0.2px;\n\n\t\twidth: fit-content;\n\t\tflex-shrink: 0;\n\t}\n\n\tinput {\n\t\tcolor: var(--text-primary, #1f2023);\n\n\t\t/* Caption 1/Regular */\n\t\tfont-family: Poppins;\n\t\tfont-size: 13px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 18px; /* 138.462% */\n\t\tletter-spacing: -0.2px;\n\n\t\twidth: 100%;\n\t\tpadding: 4px 15px;\n\t}\n}\n\n.btnBox {\n\tdisplay: flex;\n\tjustify-content: end;\n\n\tbutton {\n\t\tdisplay: flex;\n\t\tpadding: 7px 8px;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tgap: 4px;\n\n\t\tborder-radius: 8px;\n\t\tbackground: var(--primary-default, #0c6dc7);\n\n\t\tcolor: var(--text-on-color, #fff);\n\t\tfont-family: Poppins;\n\t\tfont-size: 13px;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 18px; /* 138.462% */\n\t\tletter-spacing: -0.5px;\n\t}\n}\n.closeBox {\n\tcursor: pointer;\n}\n.disabled{\n\tcursor: default;\n\tbackground: var(--primary-disabled, #c8d3e0) !important;\n}\n\n@media only screen and (max-width: 500px) {\n\t.dialogueBox {\n\t\ttop: unset;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\ttransform: unset;\n\t\twidth: 100%;\n\t}\n\n\t.btnBox {\n\t\tbutton {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogueBox": `TransferDialogue_dialogueBox__NpwmG`,
	"topHeading": `TransferDialogue_topHeading__9l594`,
	"transferBox": `TransferDialogue_transferBox__uth+G`,
	"row": `TransferDialogue_row__8ncys`,
	"btnBox": `TransferDialogue_btnBox__p6GqR`,
	"closeBox": `TransferDialogue_closeBox__7yybU`,
	"disabled": `TransferDialogue_disabled__cE-sC`
};
export default ___CSS_LOADER_EXPORT___;
